/* BLANC SPACE CUSTOM — responsive homepage proof/discovery composition. */

const DESKTOP_QUERY = '(min-width: 1000px)';

class HomeDiscoveryLayout extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.circlesSection = this.closest('.shopify-section--home-circles');
    this.ratingSection = document.querySelector('.shopify-section--home-rating-strip');
    this.phoneSection = document.querySelector('.shopify-section--home-phone-selector');

    if (!this.circlesSection || !this.ratingSection || !this.phoneSection) return;

    this.ratingAnchor = document.createComment('home-rating-strip-position');
    this.phoneAnchor = document.createComment('home-phone-selector-position');
    this.ratingSection.before(this.ratingAnchor);
    this.phoneSection.before(this.phoneAnchor);

    this.mediaQuery = window.matchMedia(DESKTOP_QUERY);
    this.abortController = new AbortController();
    this.mediaQuery.addEventListener('change', this.sync, { signal: this.abortController.signal });

    // Theme editor only: a section reload replaces the wrapper node, leaving
    // stale references here — the fresh node would then be orphaned by the
    // next restoreMobileOrder(). Re-resolve and recompose after each reload.
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:load', () => {
        const rating = document.querySelector('.shopify-section--home-rating-strip');
        const phone = document.querySelector('.shopify-section--home-phone-selector');
        if (rating) this.ratingSection = rating;
        if (phone) this.phoneSection = phone;
        if (this.ratingAnchor && !this.ratingAnchor.isConnected) this.ratingSection.before(this.ratingAnchor);
        if (this.phoneAnchor && !this.phoneAnchor.isConnected) this.phoneSection.before(this.phoneAnchor);
        this.sync();
      }, { signal: this.abortController.signal });
    }

    this.sync();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
    this.restoreMobileOrder();
    this.ratingAnchor?.remove();
    this.phoneAnchor?.remove();
  }

  sync = () => {
    if (this.mediaQuery.matches) {
      this.composeDesktopRow();
    } else {
      this.restoreMobileOrder();
    }
  };

  composeDesktopRow() {
    if (!this.desktopRow) {
      this.desktopRow = document.createElement('div');
      this.desktopRow.className = 'home-discovery-desktop-row';
      this.desktopRow.setAttribute('data-home-discovery-desktop-row', '');
    }

    this.ratingAnchor.before(this.desktopRow);
    this.desktopRow.append(this.ratingSection, this.phoneSection);
  }

  restoreMobileOrder() {
    if (this.ratingAnchor?.isConnected && this.ratingSection) {
      this.ratingAnchor.after(this.ratingSection);
    }

    if (this.phoneAnchor?.isConnected && this.phoneSection) {
      this.phoneAnchor.after(this.phoneSection);
    }

    this.desktopRow?.remove();
  }
}

if (!customElements.get('home-discovery-layout')) {
  customElements.define('home-discovery-layout', HomeDiscoveryLayout);
}
